export const allowedAligns = ['center', 'left'] as const;
export type AllowedAlign = (typeof allowedAligns)[number];
